export default "__VITE_ASSET__BDjiIBdf__"